import { AnimatedNumber } from "../animated-number";
import { Helpers } from "../helpers/helpers";
import { Modal, ModalEvent } from "../modal";

export class TeamMemberWidget {
	constructor() {
		if (Helpers.elementExists('.team-resource-button')) {
			const teamResources = document.querySelector('#team-resources') as HTMLElement;
			if (teamResources && teamResources.innerHTML.trim() != '') {
				document.querySelector('.team-resource-button').classList.remove('d-none');
			}
		}
		
		
		if (!Helpers.elementExists(".team-modal-trigger")) return;

		var modal = new Modal(".team-modal-trigger", '#primary-modal', (e: ModalEvent) => {
			document.querySelector('#primary-modal').classList.add('team-modal');
			var modalBody = document.querySelector('#primary-modal .modal-body') as HTMLElement;
			var target = e.clickEvent.target as HTMLElement;
			var modalContent = target.closest('.card').querySelector('.modal-content');
			modalBody.innerHTML = modalContent.innerHTML;
		});
	}
}